var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header",attrs:{"id":"header"}},[_c('HeaderNavbar'),_c('HeaderBanner')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }